import { render, staticRenderFns } from "./ModalImportLeads.vue?vue&type=template&id=15832273"
import script from "./ModalImportLeads.vue?vue&type=script&lang=js"
export * from "./ModalImportLeads.vue?vue&type=script&lang=js"
import style0 from "./ModalImportLeads.vue?vue&type=style&index=0&id=15832273&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports